type CopyBoxOptions = {
  boxSelector?: string;
  descSelector?: string;
  btnSelector?: string;
  textSpanSelector?: string;
};

const COPIED_LABEL = 'Скопировано';
const RESET_MS = 5000;

/** Должен вызываться синхронно из обработчика клика (иначе execCommand часто возвращает false). */
function copyTextSync(text: string): boolean {
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '0';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.focus({ preventScroll: true });
    ta.select();
    ta.setSelectionRange(0, text.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}

export function initCopyBox({
  boxSelector = '.js-copy-box',
  descSelector = '.js-copy-desc',
  btnSelector = '.js-copy-btn',
  textSpanSelector = '.text'
}: CopyBoxOptions = {}): void {
  const boxes = document.querySelectorAll<HTMLElement>(boxSelector);
  if (!boxes.length) return;

  boxes.forEach(box => {
    const desc = box.querySelector<HTMLElement>(descSelector);
    const btn = box.querySelector<HTMLButtonElement>(btnSelector);
    const textSpan = btn?.querySelector<HTMLElement>(textSpanSelector);

    if (!desc || !btn || !textSpan) return;

    const initialBtnLabel = textSpan.textContent ?? '';
    let resetTimer: ReturnType<typeof setTimeout> | null = null;

    btn.addEventListener('click', e => {
      e.preventDefault();
      const trimmed = (desc.textContent ?? '').trim();
      if (!trimmed) return;

      /** Сначала sync — иначе часто теряется user activation после await. */
      let ok = copyTextSync(trimmed);

      void (async (): Promise<void> => {
        if (!ok && navigator.clipboard?.writeText && window.isSecureContext) {
          try {
            await navigator.clipboard.writeText(trimmed);
            ok = true;
          } catch {
            // sync уже пробовали
          }
        }

        if (!ok) return;

        if (resetTimer !== null) {
          clearTimeout(resetTimer);
          resetTimer = null;
        }

        textSpan.textContent = COPIED_LABEL;

        resetTimer = setTimeout(() => {
          textSpan.textContent = initialBtnLabel;
          resetTimer = null;
        }, RESET_MS);
      })();
    });
  });
}
